import { render, staticRenderFns } from "./Report-services.vue?vue&type=template&id=fd1f47d0&scoped=true"
import script from "./Report-services.vue?vue&type=script&lang=js"
export * from "./Report-services.vue?vue&type=script&lang=js"
import style0 from "./Report-services.vue?vue&type=style&index=0&id=fd1f47d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1f47d0",
  null
  
)

export default component.exports